module.exports = __webpack_public_path__ + "static/media/map_2_bzo_1.8cfc0422.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/library/widgets/map/assets/map_2_bzo_1.svg
// module id = 754
// module chunks = 0